module.exports = __webpack_public_path__ + "img/svg/message_duotone.57b5c613ba405e7b849b3f42401b9683.svg";